export interface ColorVariant {
  text: string;
  background: string;
}

export interface ColorPalette {
  [colorName: string]: {
    light: ColorVariant;
    dark: ColorVariant;
  };
}

export const paletteColors: ColorPalette = {
  'geraldine': {
    light: {
      text: '#e57373',
      background: 'linear-gradient(to bottom, rgba(229, 130, 130, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#d84343',
      background: 'linear-gradient(to bottom, rgba(120, 30, 30, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'deep-blush': {
    light: {
      text: '#f06292',
      background: 'linear-gradient(to bottom, rgba(240, 120, 160, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#d04878',
      background: 'linear-gradient(to bottom, rgba(120, 40, 70, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'orchid': {
    light: {
      text: '#ba68c8',
      background: 'linear-gradient(to bottom, rgba(200, 140, 220, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#9844aa',
      background: 'linear-gradient(to bottom, rgba(80, 30, 100, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'true-violet': {
    light: {
      text: '#9575cd',
      background: 'linear-gradient(to bottom, rgba(160, 135, 220, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#7a5bb5',
      background: 'linear-gradient(to bottom, rgba(70, 50, 100, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'wild-blue-yonder': {
    light: {
      text: '#7986cb',
      background: 'linear-gradient(to bottom, rgba(140, 155, 220, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#5c6bc0',
      background: 'linear-gradient(to bottom, rgba(50, 60, 120, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'maya-blue': {
    light: {
      text: '#64b5f6',
      background: 'linear-gradient(to bottom, rgba(120, 190, 250, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#42a5f5',
      background: 'linear-gradient(to bottom, rgba(30, 90, 150, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'medium-turquoise': {
    light: {
      text: '#4dd0e1',
      background: 'linear-gradient(to bottom, rgba(110, 220, 235, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#26c6da',
      background: 'linear-gradient(to bottom, rgba(20, 100, 120, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'puerto-rico': {
    light: {
      text: '#4db6ac',
      background: 'linear-gradient(to bottom, rgba(110, 190, 180, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#009688',
      background: 'linear-gradient(to bottom, rgba(10, 80, 70, 0.4) 0%, #1a1a1a 100%)',
    },
  },
  'de-york': {
    light: {
      text: '#81c784',
      background: 'linear-gradient(to bottom, rgba(150, 215, 150, 0.3) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#66bb6a',
      background: 'linear-gradient(to bottom, rgba(40, 100, 50, 0.4) 0%, #1a1a1a 100%)',
    },
  },

  'mindaro': {
    light: {
      text: '#ffd400',
      background: 'linear-gradient(to bottom, rgba(255, 253, 231, 1) 0%, #ffffff 100%)',
    },
    dark: {
      text: '#ffecb3',
      background: 'linear-gradient(to bottom, rgba(138, 109, 53, 0.4) 0%, #1a1a1a 100%)',
    },
  }
};
